module.exports = __webpack_public_path__ + "img/black_russian.570b6295.jpg";